export type CsvData = {
  fileName: string;
  tableNames: string[];
  tables: unknown[][] | null;
};

export function registrosToCsv<Registro>(
  registros: Registro[],
  fileName: string,
  keys?: string[],
  extra?: string[]
) {
  let blobArray = convertObjectArrayToCSV(registros, keys);

  if (extra) {
    blobArray = blobArray.concat(extra);
  }

  const blobUrlFile = URL.createObjectURL(
    new Blob(blobArray, { type: "text/csv" })
  );
  generateDownloadLink(blobUrlFile, fileName);
}

export function multiRegistrosToCsv(csvData: CsvData, keys?: string[]) {
  if (!csvData?.tables) {
    return;
  }

  let blobArray: string[] = [];

  for (const [idx, table] of csvData.tables.entries()) {
    blobArray.push(csvData.tableNames[idx] || "");
    blobArray.push("\n");
    blobArray = blobArray.concat(convertObjectArrayToCSV(table, keys));
  }

  const blobUrlFile = URL.createObjectURL(
    new Blob(blobArray, { type: "text/csv" })
  );
  generateDownloadLink(blobUrlFile, csvData.fileName);
}

export function convertObjectArrayToCSV<Registro>(
  registros: Registro[],
  keys?: string[]
): string[] {
  if (!registros.length) {
    return [""];
  }

  // gerando lista de chaves de Registro
  let chaves: string[];

  // caso uma lista de chaves tenha sido fornecida
  if (keys) {
    chaves = keys;
  } else {
    const obj = {};
    const firstRegistro = registros[0] as Registro;
    Object.assign(obj, firstRegistro);
    chaves = keys || Object.keys(obj);
  }

  const blobArray: string[] = [];

  // linha titulo do csv
  blobArray.push(chaves.map((chave) => chave.toUpperCase()).join(";"));
  blobArray.push("\n");

  // cada registro da array vira uma linha
  for (const registro of registros) {
    const tempArr: string[] = [];

    for (const chave of chaves) {
      let addItem = registro[chave];

      if (typeof registro[chave] === "number") {
        addItem = `"${registro[chave].toLocaleString("pt-BR")}"`;
      } else {
        if (addItem && typeof addItem === "string" && addItem.includes(",")) {
          addItem = `"${registro[chave]}"`;
        }
      }

      tempArr.push(addItem);
    }

    blobArray.push(tempArr.join(";"));
    blobArray.push("\n");
  }

  blobArray.push("\n");
  return blobArray;
}

export function generateDownloadLink(
  blobUrlFile: string,
  fileName: string
): void {
  const linkDownload = document.createElement("a");
  linkDownload.href = blobUrlFile;
  linkDownload.download = `${fileName}.csv`;
  document.body.appendChild(linkDownload);
  linkDownload.click();
  document.body.removeChild(linkDownload);
}

/**
* EXEMPLO DE CSV GERADO A PARTIR DO RELATÓRIO FINANCEIRO BALANCETE:
*
** Despesas
** CATEGORIA;TOTAL;25/10/2022 A 31/10/2022;01/11/2022 A 07/11/2022;08/11/2022 A 14/11/2022;15/11/2022 A 21/11/2022;22/11/2022 A 25/11/2022
** ;25634.75;2.5;25368.25;9;0;255
** Mineralis;4920;0;500;4420;0;0
** Animal;25;25;0;0;0;0
** Teste;20;20;0;0;0;0
** Vegetais;100;100;0;0;0;0
**
** Receitas
** CATEGORIA;TOTAL;25/10/2022 A 31/10/2022;01/11/2022 A 07/11/2022;08/11/2022 A 14/11/2022;15/11/2022 A 21/11/2022;22/11/2022 A 25/11/2022
** ;17013.87;500;10400;5903.87;0;210
** Mineralis;9470;300;3000;6170;0;0
** Animal;355;230;0;125;0;0
** Teste;0;0;0;0;0;0
** Vegetais;10;10;0;0;0;0
**
** Resultados Finais
** PERIODO;SALDO_INICIAL;TOTAL_RECEITA;TOTAL_DESPESA;SALDO_ACUMULADO
** 25/10/2022 a 31/10/2022;0;1040;147.5;892.5
** 01/11/2022 a 07/11/2022;892.5;13400;25868.25;-11575.75
** 08/11/2022 a 14/11/2022;-11575.75;12198.87;4429;-3805.88
** 15/11/2022 a 21/11/2022;-3805.88;0;0;-3805.88
** 22/11/2022 a 25/11/2022;-3805.88;210;255;-3850.88

*/
